<template>
<transition name="fade">
   <div class="content-wrapper full-page-wrapper auth-pages login-2" style="background:#f8f8f8">
       <!-- <particles-bg type="random" :bg="true" /> -->
        <div class="row h-100">
            <div class="col-lg-4 carouselPanel d-none d-sm-none d-md-block text-center pt-3" >
                 <!--  <img :src="'/images/background/'+baner+'.png'" alt="Slide1" width="600px"><br> -->
            </div>
            <div class="col-lg-4 carouselPanel loginPanel">
                <div class="card">
                        <div class="card-body px-5 py-5">
                         <!--     <div class="text-uppercase" style="background: #29B3A6;color:#fff;padding:15px 10px 2px 10px;text-align:center;border-radius:20px">
                        <h6 v-if="baner===3">Vos informations sont 100% sécurisées et confidentielles</h6>
                        <h6 v-if="baner===2">Gérer vos opérations depuis une plateforme simple d’utilisation</h6>
                        <h6 v-if="baner===1">Payez, Recevez et envoyez de l’argent partout et à tout moment !</h6>
                    </div> -->
                            <h5 class="text-left col-lg-12 hed pt-5 col-12 mb-0">
                         <span style="border-radius:10px;margin-bottom:5px" class="text-uppercase">
                              Récupérez votre mot de passe 
                              </span>
                            <br>
                            <br>
                            <small class="mt-2">
                                Votre email est nécessaire pour la récupération de votre mot de passe. Veuillez saisir votre email, puis validez pour recevoir un lien de recupération de mot de passe.
                            </small></h5>
                           
                           <div class="col-lg-12 mb-0 mt-0 pt-0" v-show="errors.reset">
                            <div  class="alert alert-warning ml-3 mr-3 pt-2 pb-2 mt-0 mb-0"  :type="state">{{$t(errors.reset)}}</div>
                            </div>
                            <div style="text-align: center" v-if="submitting"><img style="width: 40px" alt="loader" src="/loaders/loader.gif"/></div>
                           <div class="col-12 mt-0 pt-0 mb-0 pb-0">
                            <form class="row">
                                <div class="form-group col-ms-12 col-lg-12 mt-0 mb-0 pb-0">
                                    <input type="text" id="email" class="form-control p_input" v-model="email" placeholder="Votre adresse e-mail">
                                </div>
                                <div class="text-center col-lg-12 col-xs-12 mt-0 pt-0">
                                    <button @click.prevent="submitForm" type="submit" class="btn btn-primary btn-md enter-btn pt-2 pb-2">RECEVOIR UN EMAIL</button>
                                </div>
                                <div class="form-group col-lg-12 col-xs-12  text-center loginBottom">
                                    <span class="text-center"> <router-link to="/login" class="connect-btn" style="color: white!important;"> Je souhaite  me connecter</router-link></span>
                                </div>
                                <div class="col-12 text-center mb-0 pb-0">
                        <img src="/images/logo_large_white.png" alt="intram_logo" width="70px">
                    </div>
                            </form>
                            </div>
                        </div>
                        </div>
                    </div>
    </div>
    </div>
</transition>
</template>

<script>
    /*eslint-disable*/
    import helpers from "../../mixins/helpers";

    export default {
        name: "PasswordForget",
        mixins:[helpers(this)],
        data(){
          return {
              baner:(Math.floor(Math.random() * 3) + 1),
              email :undefined,
              errors:{},
              state:'',
              submitting:false,
          }
        },
        methods:{
            checkisDashboard(){
                this.$emit('checkisDashboard',false);
            },
            submitForm(){
                let VueBox = this;
                if (VueBox.email===undefined){
                    VueBox.state = 'error';
                    VueBox.errors.reset =  VueBox.$t('email_required');
                    return;
                }else{
                    if (!this.isValidEmailAddress(VueBox.email)){
                        VueBox.state = 'error';
                        VueBox.errors.reset =  VueBox.$t('invalid_email');
                        return;
                    }
                }
                VueBox.submitting = true;
                let data = new FormData();
                data.append('email',this.email);
                VueBox.$store.dispatch("auth/sendResetMail",data).then(response =>{
                    window.console.log(response);
                    VueBox.submitting = false;
                    VueBox.state=(response.error)?'error':'success';
                    VueBox.errors.reset = response.message;
                    VueBox.$forceUpdate();
                });
            },
        },
        created() {
            this.checkisDashboard();
        }
    }
</script>

<style scoped>
   .auth-pages button{
        font-size: 1rem;
    }
    .forgot-pass, .hed{
       color: #fff !important;     
    }
    .auth-pages .form-group{
        margin-bottom: 5px !important;
    }
    .model-input{
        padding: 0 90px !important;
    }
    .submit_panel{
        padding: 5px;
        font-weight: 500;
        font-size: 10pt;
         color: rgb(31, 23, 23);
        text-transform: uppercase;
    }
    .redirection_panel{
        padding: 5px;
        font-weight: 500;
        font-size: 9pt;
        color: rgb(31, 23, 23);
        text-transform: uppercase;
    }
    #countries{
        color: #0D0A0A !important;
    }
    .connect-btn{
        color: #fff;
        font-weight: 500;
        text-decoration: underline;
    }
    .loginPanel .card{
        max-height: 100vh !important;
        overflow-y: auto;
        margin-top: auto;
        margin-bottom: auto;
        border-bottom: 5px solid #29B3A6;
        background: #29B3A6;
    }
    .loginPanel{
        padding: 20px!important;
        min-height: 100vh;
        display: flex;
  align-items: center;
    }
    .requiredCheck{
        color: red;
    }
    .loginBottom{
        font-size: 12pt;
    }

    #loginCarousel{
        max-height: 100vh;
    }

    .carousel-inner{
        height: 100%;
    }
    .carousel-inner{
        background-size: cover;
        text-align: center;
    }
    .qrPanel{
        color:#fff;
        position: absolute;
        bottom: 70px;
        left: 17vw;
        width: 350px;
        padding: 20px;
        background: rgba(16, 70, 65, 0.8);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
        border-radius: 23px;
        font-size: 11pt;
        font-weight: bold;
    }
    .qrPanel img{
        width: 250px !important;
    }

    .qrPanel span{
        padding: 20px;
        margin-top: 20px;
        font-size: 11pt;
        font-weight: bold;
        text-transform: uppercase;
        color: #fff;
    }
   
    .carouselPanel{
        padding: 0;
    }
    .card-image{width: 250px}
    .auth-pages .form-group .form-control{border-radius: 6px;height: 40px;border: 1px solid rgba(0, 0, 0, 0.15);}
    .wrapper{
        margin-top: 20px;
        margin-bottom: 50px;
    }
    .background-3 {
        /*box-shadow: inset 0 0 100px hsla(0,0%,0%,.3);*/
    }
     .form-label{
        font-size: 12pt;
        font-weight: 500;
        color: #fff;
    }
   
   
    .auth-pages .form-group .form-control:focus{
        transition-duration: 5ms;
        border: 1px solid rgba(41, 179, 166, 1);
    }
    .auth-pages .form-group .form-control:hover{
        border: 1px solid rgba(41, 179, 166, 1);
        transition-duration: 5ms;
    }
.auth-pages.login-2 .card{
    min-height: unset;
}
    @media (max-width: 991px) {
        .model-input{
            padding: 0 25px !important;
        }
    }
    .carousel-item img{
        width: 100%;
    }
    .carousel-indicators li{
        color:#373737
    }
</style>
